module.exports = __webpack_public_path__ + "img/android_tutorial04.082978dd.jpg";